import { render, staticRenderFns } from "./BarTabConsumptionEventsTable.vue?vue&type=template&id=69523090&"
import script from "./BarTabConsumptionEventsTable.vue?vue&type=script&lang=js&"
export * from "./BarTabConsumptionEventsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69523090')) {
      api.createRecord('69523090', component.options)
    } else {
      api.reload('69523090', component.options)
    }
    module.hot.accept("./BarTabConsumptionEventsTable.vue?vue&type=template&id=69523090&", function () {
      api.rerender('69523090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-bar/components/BarTabConsumptionEventsTable.vue"
export default component.exports